import { createRouteRef, createSubRouteRef } from '@backstage/core-plugin-api';

export const rootRouteRef = createRouteRef({
  id: 'applications',
});

export const applicationRouteRef = createSubRouteRef({
  id: 'applications.application',
  parent: rootRouteRef,
  path: '/:applicationId',
});
